import { Component, Input, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { PickupInformation } from 'src/app/model/deliveryChoiceModels/pickupInformation.model';
import { PickupComponent } from '../../parcel-informations/delivery-choice/pickup/pickup.component';

@Component({
  selector: 'app-validate-choice',
  templateUrl: './validate-choice.component.html',
  styleUrls: ['./validate-choice.component.scss']
})
export class ValidateChoiceComponent implements OnInit {

  @Input() chosenPickup: PickupInformation;
  @Input() chosenDay: Date;
  @Input() title: String;
  @Input() email : String;
  @Input() validateAction: (args: string) => void;
  @Input() modifyAction: () => void;

  isEmailValid: boolean = false;
  // emailInput: string;

  constructor(
    public dialogRef: MatDialogRef<PickupComponent>,
  ) { }

  ngOnInit(): void {
  }

  //fermer la popin
  onNoClick() {
    this.dialogRef.close();
  }

  checkEmail(isValid: boolean) {
    this.isEmailValid = isValid;
  }

  saveEmail(email: string) {
    this.email = email;
  }

  validate(email){
    this.validateAction(email);
  }

  modify(){
    this.modifyAction();
  }
}
